import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TableColumn, TableDataItem } from '../table/table.model';
import { columnsSimples, columnsWithNumber } from './columns';

type Item = {name: string; disabled?: boolean; grau?: number, selected?: boolean}

@Component({
  selector: 'app-table-checkbox',
  templateUrl: './table-checkbox.component.html',
  styleUrls: ['./table-checkbox.component.scss']
})
export class TableCheckboxComponent implements OnInit, OnChanges{

  protected itemSelected: any;
  otherText: string = '';

  @Input() itens: Item[] = [];

  @Input() height: string = '';
  @Input() grau = false;
  @Input() multCheck : boolean = true;
  @Input() selectAndCheck : boolean = true; // permite que selecionar e checar um item sejam independentes quando true
  @Input() columnsSizes : null | string[] = null

  searchText: string = ''

  @Output() checked = new EventEmitter<TableDataItem>();
  @Output() selected = new EventEmitter<any>();
  @Output() newOthers = new EventEmitter<any>();

  // todo apagar

  _data: TableDataItem[] = [];
 columns : TableColumn[] = []

  constructor(
    private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.parseDataAndColumnsToTable(this.itens)
  }

  parseDataAndColumnsToTable(itens: Item[]) {
    this._data = itens.map( ({name , disabled , grau , selected} , index)  => ({
      name,
      disabled : disabled ?? false,
      grau: grau ?? '-',
      selected : !!selected
    }) )


    if (this.grau ) {
      this.columns = columnsWithNumber
    } else {
      this.columns = columnsSimples
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itens']) {
      this.parseDataAndColumnsToTable(changes['itens'].currentValue)
    }
  }

  ngAfterViewInit() {

    this.cd.detectChanges();
  }

  seeItemSelected(item: any) {

    this.itemSelected = item;
    this.selected.emit(item);
  }

  checkedItem(item: TableDataItem) {
    this.checked.emit(item)
  }

  fillText(event: any) {

    this.otherText = event.target.value;
  }

  onTabClick(event: KeyboardEvent) {

    if (event.key === 'Tab') {

      this.newOthers.emit(this.otherText);
    }
  }

  onSearchTermChange(s: string) {
    const itens = this.itens.map( ({name}) => ({name , selected : false}))
    .filter(item => item.name.toLocaleLowerCase().includes(s.trim().toLocaleLowerCase()));
    this.parseDataAndColumnsToTable(itens)
  }


}
